import { Box, Modal, Text, Switch, Group, Table, Radio } from '@mantine/core'
import React, { useState, useEffect } from 'react'
import { IconCheck, IconX } from '@tabler/icons-react';
import { useStyles } from './style'
import Button from "../../../../utils/Button/index"
import Loading from '../../../../utils/Loading'
import { baseURL } from '../../../../config/urls';
import { doRedirectIfUnAuth, getHeader } from '../../../../config/userSession';
import BankIcon from '../../../../assets/icons/bankIcon.svg';
const ConfirmAction = ({paymentBreakup, modalOpen, onClose, currentAmount, onYes, currentElement, autoPayEnabled, setAutoPayEnabled, autoPayText, selectedPaymentMethod, setSelectedPaymentMethod, paymentErrorText}) => {

    const {classes,theme} = useStyles(useStyles);
    const [loading , setLoading] = useState(false);
    const [accounts, setAccounts] = useState([]);
    const [defaultPaymentMethod, setDefaultPaymentMethod] = useState('');
    const getPaymentMethods = async () => {
      const response = await fetch(`${baseURL}/tenant/get-payment-details`, {
        method: 'POST',
        headers: getHeader()
      });
      let resp = await response.json();
      if(response.status === 200){      
      setAccounts(resp.data.paymentMethods);
      setDefaultPaymentMethod(resp.data.defaultPaymentMethod);
      setSelectedPaymentMethod(resp.data.defaultPaymentMethod);
      }else{
      }    
      
    };
    useEffect(() => {
        getPaymentMethods();
    }, []);
    const handleCancel = () => {
        onClose()
      }
      const ths = (
        <tr>
          <th>Charges Type</th>
          <th>Amount</th>
        
        </tr>
      );
      const rows =paymentBreakup && paymentBreakup.length> 0 && paymentBreakup.map((element) => (
        <tr key={element.description}>
          <td>{element.description}</td>
          <td>${element.amount}</td>
        </tr>
      ));
    

  return (
    <>
   {loading && <Loading/> }
    <Modal className={classes.wrapper} radius={20} onClose={handleCancel}  closeOnEscape={true} overlayProps={{
        opacity: 0.5
      }} size={"auto"} opened={modalOpen} centered closeButtonProps={{
        display: "none"
      }}>
        <Box className={classes.modal}>
          <Group position="center">
            <Table striped>
              <thead>{ths}</thead>
              <tbody>{rows}</tbody>
              <tfoot>
                <tr>
                  <th>Total</th>
                  <th size='md' >${currentAmount}</th>
                </tr>
              </tfoot>
            </Table>

            <Switch
              checked={autoPayEnabled}
              onChange={(event) => setAutoPayEnabled(event.currentTarget.checked)}
              color="teal"
              size="md"
              label={autoPayText?autoPayText: 'Enable AutoPay for this Property'}
              thumbIcon={
                autoPayEnabled ? (
                  <IconCheck size="0.8rem" color={theme.colors.teal[theme.fn.primaryShade()]} stroke={3} />
                ) : (
                  <IconX size="0.8rem" color={theme.colors.red[theme.fn.primaryShade()]} stroke={3} />
                )
              }
            />
          </Group>
         
          <Text className={classes.paymentMethod}>Select Payment Method</Text>
          {accounts?.length > 0 &&
                  accounts.map((account) => (
                   <>
                   
                      <Box className={classes.gridRowFull}>
                        <Box className={classes.gridItem}>
                          <label className={classes.label}>
                         
                          </label>

                          <Box className={classes.bankDetail} id='bank-detail'>
                          <Radio  color="secondary.0" className={classes.radioButtonPayment} checked={ (defaultPaymentMethod == account.id || selectedPaymentMethod == account.id) ? true: false} value={account.id} onChange={(event) => { console.log('event.currentTarget is ', event.currentTarget.value);setSelectedPaymentMethod(event.currentTarget.value); setDefaultPaymentMethod('')} } />
                            <img
                              width='28px'
                              height='28px'
                              className={classes.bankIcon}
                              alt='Bank'
                              src={BankIcon}
                            />
                            <Box className={classes.div}>
                              <Box className={classes.divWrapper}>
                              <Box className={classes.textWrapper}>
                                  {account.type === 'card'
                                    ? `${account?.card?.last4}`
                                    : `${account?.us_bank_account?.account_type || account?.object  } ${account?.us_bank_account?.last4 || account?.last4 } `}
                                </Box>
                              </Box>
                              <Box className={classes.textWrapper2}>
                                {account.type === 'card'
                                  ? `${account?.card?.brand}`
                                  : `${account?.us_bank_account?.bank_name || account?.bank_name }`}
                              </Box>
                            </Box>
                           
                          </Box>
                        </Box>
                      </Box>
                      </>
                   
                  ))}
          
          <Text className={classes.confirm}>Are you sure you want to pay <b>${currentAmount}</b> ?</Text>
         {paymentErrorText ?<Text className={classes.errorPayment}>{paymentErrorText} </Text>:<></>} 
          
          <Box className={classes.actions}>
            <p onClick={handleCancel} className={classes.cancel}>Cancel</p>
            <Button className={classes.btn} onClick={() => onYes(currentElement)} title='Pay' bgColor={theme.colors.primary[0]}/>
          </Box>
        </Box>
      </Modal>
      </>
  )
}

export default ConfirmAction